import { getHomePageUrl } from 'services/helpers/domain/domain';
import { locations } from 'services/routes/locations';

export const getIsStudioCheckout = (
  isAiMusicGeneratorFunnel: boolean,
  startedFrom?: string
) => {
  if (!isAiMusicGeneratorFunnel || !startedFrom) return false;

  if (!startedFrom.includes('/studio')) return false;

  return true;
};

export const getCheckoutURL = () => {
  const homePage = getHomePageUrl();

  return `${homePage}${locations.subscription.checkout.pathname}`;
};

const SUCCESS_QUERY_STRING = 'success';
const FAILURE_QUERY_STRING = 'canceled';

export type CheckoutURL = {
  successURL: string;
  cancelURL: string;
};

export const getCheckoutSuccessURL = (
  isStudioCheckout?: boolean,
  customSuccessURL?: string
) => {
  const checkout = getCheckoutURL();
  const homePage = getHomePageUrl();

  if (isStudioCheckout) {
    return `${homePage}${customSuccessURL || ''}?${SUCCESS_QUERY_STRING}`;
  }

  return `${checkout}?${SUCCESS_QUERY_STRING}`;
};

export const getCheckoutURLs = (
  isStudioCheckout?: boolean,
  customSuccessURL?: string
) => {
  const checkout = getCheckoutURL();
  const successURL = getCheckoutSuccessURL(isStudioCheckout, customSuccessURL);
  const cancelURL = `${checkout}?${FAILURE_QUERY_STRING}`;

  return {
    successURL,
    cancelURL,
  };
};
